import { FormControl } from '@chakra-ui/react';
import { EntityDirectorySelectFilter } from '@texas/components/shared/entityDirectory/EntityDirectorySelectFilter';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useMetadata } from '@texas/hooks/metadata/useMetadata';

export function SelectProductGroup({
  selectedProductGroupId,
  onSelect,
}: {
  selectedProductGroupId: number | null;
  onSelect: (id: number) => void;
}) {
  const { t } = useTranslation();

  const {
    productGroupsData: [productGroups, getProductGroups, loadingProductGroups],
  } = useMetadata();

  useEffect(() => {
    getProductGroups();
  }, [getProductGroups]);
  return (
    <FormControl w={64}>
      <EntityDirectorySelectFilter
        buttonProps={{ isDisabled: loadingProductGroups, w: 'full' }}
        placeholder={t('filter.allProductGroups')}
        value={selectedProductGroupId}
        onChange={(id) => onSelect(id ?? 0)}
        options={productGroups
          .sort((a, b) => a.value.localeCompare(b.value))
          .map((productGroup) => ({
            label: productGroup.value,
            value: productGroup.id,
          }))}
      />
    </FormControl>
  );
}
